export const getPermissionKeyFromApi = (url: string): string => {
    if (!url) return '';
    const key = url.replace(/^\/|\/$/g, '').replace(/\//g, '.');
    return key.charAt(0).toUpperCase() + key.slice(1);
};
